import React, { useMemo } from "react";
import { SearchResultLayout } from "./search_results_layout/data.view.search.results.layout";
import { NameAnd } from "@me8eon/record_utils";
import { SelectableButton } from "@me8eon/selection_button";
import { makeContextFor } from "@me8eon/context";
import { FeatureFlags, useFeatureFlags } from "@me8eon/featureflags";
import { DataWidgetWidth } from "@me8eon/data_widget";
import { useUserData } from "@me8eon/react_authentication";

export const dataViewDebug = "dataView";
export const dataViewFilterName = "dataview";

export type DataViews<SearchType extends string, DataSourceDetails> = NameAnd<DataView<SearchType, DataSourceDetails>>

export type WriteResultTo = "searchResults" | "immediateSearchResults"
export type SearchTypeDetails<DataSourceDetails> = {
    dataSource: DataSourceDetails[]
}
export type DataViewChangeViewDetails = {
    forceSearchWhenSelectView: boolean
    cleanWhenSelectView: boolean
}


export type NormalisedWidgetDefn = { widget: string, width: DataWidgetWidth }
export type WidgetDefn = string | NormalisedWidgetDefn

export function normaliseDefn(defn: WidgetDefn): NormalisedWidgetDefn {
    return typeof defn === "string" ? { widget: defn, width: "auto" } : defn;
}

export function normaliseWidgetDefns(defns: WidgetDefn[]): NormalisedWidgetDefn[] {
    return defns.map(defn => normaliseDefn(defn));
}

//for example all, jira, confluence, (maybe ai assistance)
//The search type is 'what types of search'. for example 'immediate', 'submit'
export type DataView<SearchType extends string, DataSourceDetails> = {
    searchIndices: string[];//just to keep existing code working
    needsOffice: boolean //just to keep existing code working
    plugin: "dataview" //purely for documentation and debug
    search: Partial<Record<SearchType, SearchTypeDetails<DataSourceDetails>>>
    widgets: WidgetDefn[]
    DisplayNavItem?: SelectableButton
    icon?: React.ReactElement
    changeView: DataViewChangeViewDetails
    SearchResultLayout: SearchResultLayout
    OneLineLayout: SearchResultLayout
    default?: {
        [key: string]: string;
    },
    size?: "small" | "normal";
    conditionToHide?: {
        [key: string]: (guiFilters: Record<string, string>) => boolean
    };
    filterSortOrder?: {
        [key: string]: string[];
    };
}
export const { Provider: RawDataViewsProvider, use: useDataViews } = makeContextFor<DataViews<any, any>, "dataViews">("dataViews");

export type DataViewsProviderProps = {
    children: React.ReactNode
    dataViews: (featureFlags: FeatureFlags, featureFlagEnabled: boolean, empType: string) => DataViews<any, any>
}

export function DataViewsProvider({ children, dataViews }: DataViewsProviderProps) {
    const [featureFlags] = useFeatureFlags();
    const { featureFlagEnabled, empType } = useUserData();
    const value = useMemo(() => dataViews(featureFlags, featureFlagEnabled, empType), [featureFlagEnabled, featureFlags, empType, dataViews]);
    return <RawDataViewsProvider dataViews={value}>{children}</RawDataViewsProvider>;
}
